const ManagePharmacyPage = () => {
  return (
    <div>
      <h1>Manage Pharmacy</h1>
    </div>
  );
};

export default ManagePharmacyPage;
